function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useContext, useEffect, useState } from "react";
import { Dialog as DialogRoot, DialogPortal, DialogOverlay, DialogContent, DialogTitle } from "@radix-ui/react-dialog";
import cc from "classcat";
import PropTypes from "prop-types";
import { SidebarContext } from "./SidebarContext";
import { useNavigation, useResolvedPath } from "react-router-dom";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
SidebarMobile.propTypes = {
    children: PropTypes.node.isRequired,
    shouldHideSidebar: PropTypes.bool,
    setShouldHideSidebar: PropTypes.func.isRequired
};
export default function SidebarMobile(param) {
    var children = param.children, _param_shouldHideSidebar = param.shouldHideSidebar, shouldHideSidebar = _param_shouldHideSidebar === void 0 ? false : _param_shouldHideSidebar, setShouldHideSidebar = param.setShouldHideSidebar;
    var _useContext = useContext(SidebarContext), isOpen = _useContext.isOpen, setIsOpen = _useContext.setIsOpen;
    var _useState = _sliced_to_array(useState(false), 2), fadeIn = _useState[0], setFadeIn = _useState[1];
    var resolvedPath = useResolvedPath();
    var navigation = useNavigation();
    useEffect(function() {
        if (!shouldHideSidebar) {
            return;
        }
        hideSidebar();
        setShouldHideSidebar(false);
    }, [
        shouldHideSidebar
    ]);
    /**
     * First animate out, wait 300ms while the animation ends then mark the sidebar as hidden(closed)
     */ function hideSidebar() {
        setFadeIn(false);
        setTimeout(function() {
            setIsOpen(false);
        }, 300);
    }
    useEffect(function() {
        return function() {
            setIsOpen(false);
        };
    }, []);
    /**
     * Animate the sidebar if the "isOpen" status change to true
     */ useEffect(function() {
        if (isOpen) {
            requestAnimationFrame(function() {
                setFadeIn(true);
            });
        }
    }, [
        isOpen
    ]);
    /**
     * We want to close the sidebar if the page changes
     */ useEffect(function() {
        if (!isOpen) {
            return;
        }
        hideSidebar();
    }, [
        resolvedPath.pathname,
        navigation.state
    ]);
    return /*#__PURE__*/ React.createElement(DialogRoot, {
        open: isOpen
    }, /*#__PURE__*/ React.createElement(DialogPortal, null, /*#__PURE__*/ React.createElement(DialogOverlay, {
        className: cc([
            "fixed top-0 z-20 h-full w-full bg-gray-700 transition-all duration-300",
            {
                "opacity-0": !fadeIn
            },
            {
                "opacity-50 dark:opacity-60": fadeIn
            }
        ]),
        onClick: hideSidebar
    }), /*#__PURE__*/ React.createElement(DialogContent, {
        "aria-describedby": undefined,
        className: cc([
            "fixed left-0 top-0 z-50 h-full w-72 transition-all duration-300 focus:outline-none",
            {
                "-translate-x-full": !fadeIn
            },
            {
                "translate-x-0": fadeIn
            }
        ])
    }, /*#__PURE__*/ React.createElement(VisuallyHidden.Root, {
        asChild: true
    }, /*#__PURE__*/ React.createElement(DialogTitle, null, "Sidebar menu navigation")), children)));
}
